import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ITableColumn} from '../../../../../../shared/shared/table/table-column';
import {ITableDataItem} from '../../../../../../shared/shared/table/table-data-item';
import {IImportStatistics, IUploadFilesServiceToken, UploadFilesService} from '../../upload-files.service';

@Component({
  selector: 'app-upload-preview-step',
  templateUrl: './upload-preview-step.component.html',
  styleUrls: ['./upload-preview-step.component.scss'],
  providers:[{
            provide: IUploadFilesServiceToken, useExisting: UploadFilesService
        }]
})
export class UploadPreviewStepComponent{

    @Input() previewData: ITableDataItem []=[];
    @Input() invalidData: ITableDataItem []=[];
    @Input() statistics:IImportStatistics = null;
    @Input() columns: ITableColumn[] = [];
    @Input() isImporting: boolean = false;
    @Input() isImported: boolean = false;
    
    @Output() importXLSClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() exportFailedDataClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() previewNextClicked: EventEmitter<void> = new EventEmitter<void>();
 
    importXLS() {
        this.importXLSClicked.next();
    }

    goToNextFromPreview() {
        this.previewNextClicked.next();
    }
    
    exportFailedData() {
        this.exportFailedDataClicked.next();   
    }

    hasWarningsOrErrors(items: any): boolean {
        return !!items && Object.keys(items).length > 0;
    }

}
